<mat-dialog-content class="table-div">
  <app-generic-table [columns]="columns" [displayedColumns]="displayedColumns"
    [data]="data" [showGoogleMap]="true" [showExportButton]="true" [showClose]="true"
    [customSort]="customSort"
    [actionOneIcon]="'remove_red_eye'" (onActionOne)="goToDemandPage($event)"
    (onRowDoubleClick)="goToDemandPage($event)" (onClose)="close()">
  </app-generic-table>
</mat-dialog-content>